<div class="btn-withTooltip">
  <gl-button data-testid="ToolbarPrintIcon" icon icon-center="glicon-print" (onClick)="print()"> </gl-button>
  <div class="btn-withTooltip__item">
    {{ 'actions.print' | translate }}
  </div>
</div>
